import { Component } from 'react';
import {
  Avatar,
  FormControl,
  Grid,
  ListItem,
  ListItemAvatar,
  ListItemText,
  InputLabel,
  MenuItem,
  Select,
  Typography,
  Divider
} from '@mui/material';

const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;
let CHARACTERS = Constants.CHARACTERS;

function getStyles(player, gpRoster, theme) {
  return {
    fontWeight: gpRoster.some(selected => selected.playerId === player.playerId)
      ? theme.typography.fontWeightMedium
      : theme.typography.fontWeightRegular,
    backgroundColor: gpRoster.some(selected => selected.playerId === player.playerId)
      ? '#66d97f'
      : 'inherit',
  };
}

class GrandPrixEntryPlayer extends Component {
  constructor(props) {
    super(props);
    this.id = props.id;
  }

  render() {
    const { roster, gpRoster = [], handlePlayerSelect, theme } = this.props;

    // Separate selected and unselected players
    const selectedPlayers = roster.filter(player => gpRoster.some(selected => selected.playerId === player.playerId));
    const unselectedPlayers = roster.filter(player => !gpRoster.some(selected => selected.playerId === player.playerId));

    return (
      <FormControl fullWidth sx={{ mt: 2, width: '90%' }}>
        <InputLabel id="multiple-name-label">Add / Remove Player</InputLabel>
        <Select
          labelId="multiple-name-label"
          id="multiple-name"
          multiple
          displayEmpty
          label="Add / Remove Player"
          variant='outlined'
          value={gpRoster}
          onChange={(e) => handlePlayerSelect(e)}
          renderValue={(selected) => (
            <Grid container spacing={{ xs: 1, md: 2 }} columns={{ xs: 1, sm: 8, md: 12 }} sx={{ textAlign: 'center' }}>
              {selected.map((player, index) => (
                <Grid item xs={2} sm={4} md={4} key={index} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', textAlign: 'center', mt: 1 }}>
                  <ListItem key={JSON.stringify(player)} className={`${player.firstName} ${player.lastName}`} sx={{ padding: 0 }}>
                    <ListItemAvatar>
                      <Avatar
                        alt={`Avatar n°${player.playerId + 1}`}
                        src={`${IMAGE_URL}${CHARACTERS[parseInt(player.characterId) - 1]['url']}`}
                        variant={'square'} />
                    </ListItemAvatar>
                    <ListItemText>
                      <Typography variant="body1" sx={{ fontSize: "80%" }}>
                        {player.firstName} {player.lastName}
                      </Typography>
                    </ListItemText>
                  </ListItem>
                </Grid>
              ))}
            </Grid>
          )}
        >
          {/* Render selected players */}
          {selectedPlayers.map((player) => (
            <MenuItem
              key={player.playerId}
              value={JSON.stringify(player)}
              style={getStyles(player, gpRoster, theme)}
              sx={{m: .25}}
            >
              <ListItemAvatar>
                      <Avatar
                        alt={`Avatar n°${player.playerId + 1}`}
                        src={`${IMAGE_URL}${CHARACTERS[parseInt(player.characterId) - 1]['url']}`}
                        variant={'square'} />
                    </ListItemAvatar>
                    <ListItemText>
                      <Typography variant="body1" sx={{ fontSize: "80%" }}>
                        {player.firstName} {player.lastName}
                      </Typography>
                    </ListItemText>
            </MenuItem>
          ))}

          {/* Divider for visual separation */}
          {selectedPlayers.length > 0 && <Divider />}

          {/* Render unselected players */}
          {unselectedPlayers.map((player) => (
            <MenuItem
              key={player.playerId}
              value={JSON.stringify(player)}
              style={getStyles(player, gpRoster, theme)}
              sx={{m: .25}}
            >
              <ListItemAvatar>
                      <Avatar
                        alt={`Avatar n°${player.playerId + 1}`}
                        src={`${IMAGE_URL}${CHARACTERS[parseInt(player.characterId) - 1]['url']}`}
                        variant={'square'} />
                    </ListItemAvatar>
                    <ListItemText>
                      <Typography variant="body1" sx={{ fontSize: "80%" }}>
                        {player.firstName} {player.lastName}
                      </Typography>
                    </ListItemText>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  }
}

export default GrandPrixEntryPlayer;
